import React from 'react';
import { DownloadIcon } from 'lucide-react';
export function CvDownloadButton() {
  const handleDownload = () => {
    window.print();
  };
  return <div className="flex flex-col items-center gap-3" data-id="element-29">
      <button type="button" onClick={handleDownload} className="inline-flex items-center gap-2 rounded-full border border-charcoal/25 px-6 py-3 text-sm font-medium text-charcoal transition-colors duration-300 hover:border-amber hover:text-amber focus:outline-none focus-visible:ring-2 focus-visible:ring-amber focus-visible:ring-offset-2" data-id="element-30">
        <DownloadIcon size={17} aria-hidden="true" data-id="element-31" />
        Download CV (PDF)
      </button>
      <p className="max-w-xs text-center text-xs font-light leading-relaxed text-charcoal/50" data-id="element-32">
        Opens your browser&apos;s print dialog. Choose “Save as PDF” to
        download.
      </p>
    </div>;
}